<template>
    <div class="pt440" id="pt440">
        <breadcrumb :navListCustom="[{title:'マイページ', routerName: SiteConstants.PG010MAIN, param: {pageNo: '81'}}, {title:'お気に入り', routerName: '', param: {}}]"></breadcrumb>
        <h2>{{$t('common.labels.myPgage')}}</h2>
        <div class="section-inner">
            <!--お気に入りタイトル-->
            <h3>{{$t('common.labels.favorite')}}</h3>
            <!--登録件数表示-->
            <p class="mb32"><strong>{{$t('pt440.labels.productAdded')}}{{pt440Init.totalRecord}}{{$t('common.labels.item')}}</strong></p>
            <div v-if="isPagingDisplay">
                <page-feed
                    :isDisplay="isPagingDisplay"
                    :pageFeedData="pageFeedData"
                    :orderByType="ptOrderByType"
                    :dispPageSizeList="dispPageSizeList"
                    :isDisplaySort="isSortDisp"
                    :dispSortList="favouriteSortKbnList"
                    @search="changeSearch"
                    >
                    <template slot="TableRender" v-if="pt440Init.designFlg == 0">
                        <div v-if="getLengthObj(pt440Init.favouriteList) > 0" class="pt440FavouriteMain">
                            <!--page table -->
                            <ul class="pt440FavouriteMainItemList">
                                <li v-for="(item, index) in pt440Init.favouriteList" :key="index">
                                    <div style="position:relative;" class="pt440FavouriteMainItemListProduct">
                                        <a class ="pt440FavouriteMainItemListProductLink" :title="item.WEB_ITEM_NM" @click="doDetail(item.S_ITEM_NO)">
                                            <!--商品画像-->
                                            <img :src="item.IMG_URL1" @error="getErrImage" class="mb08" style="width:142px; height:142px;" :style="pt440Init.itemImgFlg == 0?'display:none;':''"/>
                                            <!--商品名 -->
                                            <span class="item-list-detail">
                                                <strong class="mb05 webNm dropText" style="visibility: visible;">
                                                    <span :title="item.CATCH_COPY_PRE">{{item.CATCH_COPY_PRE}}</span><br/>
                                                    <span :title="item.WEB_ITEM_NM">{{item.WEB_ITEM_NM}}</span><br/>
                                                    <span :title="item.CATCH_COPY_SUF">{{item.CATCH_COPY_SUF}}</span>
                                                </strong>
                                            </span>
                                            <!--通常商品またはポイント交換-->
                                            <template v-if="(item.POINT_ITEM_KBN == '0' || item.POINT_ITEM_KBN == '2') && pt440Init.priceShow != 1">
                                                <!--税込の場合-->
                                                <div class="mb05" v-if="pt440Init.tnkDspKbn == 1">
                                                    <!--税込価格 -->
                                                    <span class="generalZeiPrice">{{formatPrice(item.PRICE_ZEI)}}{{$t('common.labels.jpYen')}}</span>
                                                    <span class="zeiPriceTax">{{$t('common.labels.taxIncludeSale[1]')}}</span>
                                                </div>
                                                <div v-else>
                                                    <!--税抜価格 -->
                                                    <span class="generalPrice">{{formatPrice(item.PRICE)}}{{$t('common.labels.jpYen')}}</span>
                                                    <span class="priceTax">{{$t('common.labels.taxIncludeSale[2]')}}</span><br>
                                                    <!--税込価格 -->
                                                    <span class="generalZeiPrice">{{formatPrice(item.PRICE_ZEI)}}{{$t('common.labels.jpYen')}}</span>
                                                    <span class="zeiPriceTax">{{$t('common.labels.taxIncludeSale[1]')}}</span>
                                                </div>
                                            </template>
                                            <!--ポイント交換-->
                                            <template v-if="(item.POINT_ITEM_KBN == '1' || item.POINT_ITEM_KBN == '2') && pt440Init.priceShow != 1">
                                                <div class="mb05">
                                                    <span class="price">
                                                        {{formatPrice(item.POINT_ITEM_NUM)}}{{$t('common.labels.pt')}}
                                                    </span>
                                                </div>
                                            </template>

                                            <div class="mb05" v-if="item.HANBAI_FLG == '1'">
                                                <!-- 在庫状態 -->
                                                <template v-if="item.ZAIKO_DISP_WAY_KBN == '2' || item.ZAIKO_DISP_WAY_KBN == '3'">
                                                    <!-- 在庫数 -->
                                                    <p>{{$t('pt120.labels.numberOfStock')}}：{{item.STOCK}}</p>
                                                </template>
                                                <!-- 在庫状態表示、両方表示の場合 -->
                                                <template v-if="item.ZAIKO_DISP_WAY_KBN == '1' || item.ZAIKO_DISP_WAY_KBN == '3'">
                                                    <!-- 在庫なし-->
                                                    <template v-if="item.STOCK <= 0">
                                                        <p v-if="item.ZAIKO_MSG3 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.none')}}</p>
                                                        <p v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{item.ZAIKO_MSG3}}</p>
                                                    </template>
                                                    <!-- 残りわずか -->
                                                    <template v-else-if="item.STOCK > 0 && item.STOCK <= item.ZAIKO_CNT">
                                                        <p v-if="item.ZAIKO_MSG2 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.onlyFewRemaining')}}</p>
                                                        <p v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{item.ZAIKO_MSG2}}</p>
                                                    </template>
                                                    <!-- あり -->
                                                    <template v-else-if="item.STOCK > item.ZAIKO_CNT">
                                                        <p v-if="item.ZAIKO_MSG1 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.there')}}</p>
                                                        <p v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{item.ZAIKO_MSG1}}</p>
                                                    </template>
                                                </template>
                                            </div>
                                        </a>
                                        <div class="fave-btn">
                                            <!-- カートに入れる -->
                                            <input type="button" class="Pt440CartInto" v-if="item.STOCK != 0 && item.HANBAI_FLG == '1'" @click="doOrder(item.S_ITEM_NO, item.PRICE, item.WEB_ITEM_NM,item.IMG_URL1)" :value="$t('common.buttons.buttonOrder')">
                                            <!-- 在庫切れ -->
                                            <input type="button" class="Pt440outStock" v-else-if="item.HANBAI_FLG == '1'" :value="$t('pt440.buttons.outStock')">
                                            <!-- お気に入り解除 -->
                                            <input type="button" class="Pt440kaijyou" @click="doDelete(item.S_ITEM_NO)" :value="$t('common.buttons.cancelFavorite')">
                                        </div>
                                        <span class="pt440Clearfix">
                                            <span class="mr05" v-if="item.CONVENI_UKE_FLG == 1"><img src="../img/icons/convenience.gif" @error="getErrImage" width="25" height="25" :alt="$t('pt120.labels.convenienceStoreReceipt')"></span>
                                            <span class="mr05" v-if="item.YUUBINKYOKU_UKE_FLG == 1"><img src="../img/icons/jp_logo.gif" @error="getErrImage" width="25" height="25" :alt="$t('pt120.labels.postOfficeRecept')"></span>
                                            <span class="mr05" v-if="item.HAKOPOST_UKE_FLG == 1"><img src="../img/icons/jp_hako_logo.gif" @error="getErrImage"  width="25" height="25" :alt="$t('pt120.labels.happy')"></span>
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </template>
                    <!--オプション:縦レイアウト -->
                    <template slot="TableRender" v-else>
                        <div v-if="getLengthObj(pt440Init.favouriteList) > 0 && pt440Init.cartButtonFlg == 1" id="cart-add">
                            <!--カートに追加ボタン-->
                            <input id="cart-add-button" @click="doOrderPt440(pt440Init.favouriteList)" :value="$t('pt440.buttons.cartAddBtn')" type="button">
                        </div>
                        <table id="product-list">
                            <tr v-for="(product, index) in pt440Init.favouriteList" :key="index">
                                <th id="itemListImg" :style="pt440Init.itemImgFlg == 0?'display:none;':''">
                                    <img style="width:80px; height:80px;" :src="product.IMG_URL1" @error="getErrImage">
                                </th>
                                <td>{{product.S_ITEM_NO}}</td>
                                <td>
                                    <ul>
                                        <li>{{product.CATCH_COPY_PRE}}</li>
                                        <li>{{product.WEB_ITEM_NM}}</li>
                                        <li>{{product.CATCH_COPY_SUF}}</li>
                                        <li>
                                            <template v-if="product.YOYAKU_ITEM_FLG == 1">
                                                {{$t('pt110.labels.releaseDate')}}: {{product.SELL_YMD}}&nbsp;
                                            </template>
                                            <template v-if="product.HANBAI_FLG == 1">
                                                <template v-if="(product.ZAIKO_DISP_PLACE_KBN== '0' || product.ZAIKO_DISP_PLACE_KBN == '1') && product.ZAIKO_DISP_WAY_KBN !='0'">
                                                    <!-- 入荷待ち予約注文可 -->
                                                    <template v-if="product.STOCK == '9999999'">
                                                        {{$t('pt110.labels.stock')}}：{{$t('pt110.labels.availableForBackorderPreorderAvailable')}}
                                                    </template>
                                                    <template v-else>
                                                        <!--在庫数表示、両方表示の場合 -->
                                                        <template v-if="product.ZAIKO_DISP_WAY_KBN == '2' || product.ZAIKO_DISP_WAY_KBN == '3'">
                                                            {{$t('pt120.labels.numberOfStock')}}：{{formatPrice(product.STOCK)}}&nbsp;
                                                        </template>
                                                        <!-- 在庫状態表示、両方表示の場合 -->
                                                        <template v-if="product.ZAIKO_DISP_WAY_KBN == '1' || product.ZAIKO_DISP_WAY_KBN == '3'">
                                                            <!-- 在庫なし-->
                                                            <template v-if="product.STOCK <= 0">
                                                                <template v-if="product.ZAIKO_MSG3 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.none')}}</template>
                                                                <template v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG3}}</template>
                                                            </template>
                                                            <!-- 残りわずか -->
                                                            <template v-else-if="product.STOCK > 0 && product.STOCK <= product.ZAIKO_CNT">
                                                                <template v-if="product.ZAIKO_MSG2 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.onlyFewRemaining')}}</template>
                                                                <template v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG2}}</template>
                                                            </template>
                                                            <!-- あり -->
                                                            <template v-else-if="product.STOCK > product.ZAIKO_CNT">
                                                                <template v-if="product.ZAIKO_MSG1 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.there')}}</template>
                                                                <template v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG1}}</template>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>
                                        </li>
                                    </ul>
                                </td>
                                <td v-if="pt440Init.cartButtonFlg == 1">
                                    <!-- 数量： -->
                                    <div class="itemQty">
                                        <span>
                                            {{$t('common.labels.quantity')}}:
                                            <input-check v-if="product.STOCK > 0" v-model="product.QTY" :value="0" type="text" maxlength="5" size="5"
                                                class="productQty num" :id="'itemQty_' + index" @on-change="getAnimalQty(product.QTY, index, product.SYUKKA_NUM)"/>
                                            <input-check v-else v-model="product.QTY" disabled :value="0" type="text" maxlength="5" size="5"
                                                class="productQtyDisabled num" :id="'itemQty_' + index"/>
                                        </span>
                                    </div>
                                </td>
                                <td v-if="pt440Init.auraOpt == 1 && pt440Init.cartButtonFlg == 1">
                                    <!-- 匹数： -->
                                    <div class="animalQty">
                                        <span>
                                            {{$t('common.labels.animalQty')}}:
                                            <input-check type="text" class="productQty num" :id="'animalQty_' + index" maxlength="7" size="7" v-model="product.ANIMAL_QTY" :value="0"
                                                @on-change="getItemQty(product.ANIMAL_QTY, index, product.SYUKKA_NUM)" :disabled="product.SYUKKA_NUM === 1 ? true : false"/>
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <template v-if="(product.POINT_ITEM_KBN == '0' || product.POINT_ITEM_KBN == '2') && pt440Init.priceShow != 1">
                                        <!--税込金額 -->
                                        <span v-if="product.TNK_DSP_KBN == '1'">
                                            {{formatPrice(product.PRICE_ZEI)}}{{$t('common.labels.jpYen')}}
                                        </span>
                                        <!--税抜金額 -->
                                        <span v-else>
                                            {{formatPrice(product.PRICE)}}{{$t('common.labels.jpYen')}}
                                        </span>
                                        <template v-if="product.ITEM_ZEI_SET_KBN != '0'">
                                            <!-- (税込) -->
                                            <template v-if="product.TNK_DSP_KBN == '1'">{{$t('common.labels.taxincluded')}}</template>
                                            <!-- (税抜) -->
                                            <template v-else>{{$t('common.labels.excludingtax')}}</template>
                                        </template>
                                    </template>
                                    <!--ポイント交換商品-->
                                    <template v-if="(product.POINT_ITEM_KBN == '1' || product.POINT_ITEM_KBN == '2') && pt440Init.priceShow != 1">
                                        <span class="price">
                                            {{formatPrice(product.POINT_ITEM_NUM)}}{{$t('common.labels.pt')}}
                                        </span>
                                    </template>
                                </td>
                                <td>
                                    <!-- 注文画面へ -->
                                    <input id="deteleFavourite" type="button" v-if="product.STOCK != 0 && product.HANBAI_FLG == '1'" @click="doDetail(product.S_ITEM_NO)" :value="$t('pt110.labels.toDetail')">
                                    <!-- 在庫切れ -->
                                    <input id="zaikoFavourite" type="button" class="outStock" v-else-if="product.HANBAI_FLG == '1'" :value="$t('pt440.buttons.outStock')">
                                    <!-- お気に入り解除 -->
                                    <input id="deleteFavourite" type="button" @click="doDelete(product.S_ITEM_NO)" :value="$t('common.buttons.cancelFavorite')">
                                </td>
                            </tr>
                        </table>
                    </template>
                </page-feed>
            </div>
            <!--戻るボタン-->
            <div id="btn_roll3" v-if="pt440Init.backButtonFlg == 1">
                <a class="submit-button-back" @click="backUrl()">{{$t('common.buttons.return')}}</a>
            </div>
        </div>
        <!-- modal confirm area -->
        <alert-confirm
            v-if="isModalShow"
            :msgConfirm="msgConfirm"
            :isButtonCancel="false"
        >
        </alert-confirm>
        <COLOR_SIZE v-if="colorSizeFlg" :data="dataColorSize" @modal-close="colorSizeFlg = false" @set-addr-value="setValue"></COLOR_SIZE>
    </div>
</template>

<script>
/*
* Import libs and componnents
*/
import axios from "assets/js/request";
import common from 'assets/js/common';
import PageFeed from "../commonParts/PageFeed";
import SiteConstants from 'assets/const/SiteConstants.json';
import InputNumber from 'components/InputNumber';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import AlertConfirm from 'components/AlertConfirm';
import EventBus from 'assets/js/eventBus';
import toastr from "toastr/toastr.js";
import "toastr/build/toastr.min.css";
import COLOR_SIZE from '../parts/PT110_colorSizeModal.vue';
import InputCheck from 'components/InputCheck.vue';
import commonEc from "assets/js/common_ec";

toastr.options = {
  closeButton: true,
  positionClass: "toast-top-right",
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "2000",
};

export default {
    /*
    * Name of component
    */
    name: "pt440",
    /* 
    * Declare components
    */
    components: {
        PageFeed,
        InputNumber,
        Breadcrumb,
        AlertConfirm,
        EventBus,
        toastr,
        COLOR_SIZE,
        InputCheck
    },
    /*
    * Declare props
    */
    props: {
        ptPageNo: {
            type: [Number,String]
        },
        ptPageSize: {
            type: [Number,String]
        },
        ptOrderByType: {
            type: [Number,String]
        },
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    /*
    * Declare variable and set default value
    */
    data: function() {
        return {
            isDisplay: false,
            isPagingDisplay: false,
            isModalShow:false,
            isSortDisp: false,
            msgConfirm:'',
            pt440ReqModel: {
                sItemNo: null,
                orderType: 0,
                totalRecord: null,
                fromRecord: null,
                toRecord: null,
                pageSize: this.ptPageSize != undefined ? this.ptPageSize : 16,
                pageNo: this.ptPageNo != undefined ? this.ptPageNo : 1
            },
            pt440Init: {
                pageNo: null,
                pageSize: null,
                favouriteList: {},
                backButtonFlg: 0
            },
            favouriteSortKbnList: [],
            pt440Valid: {},
            queryData: null,
            pageFeedData: {
                totalRecord: 50,
                fromRecord: 1,
                toRecord: 10,
                pageSize: 16,
                pageNo: 1
            },
            dispPageSizeList:[],
            SiteConstants: SiteConstants,
            site: "",
            colorSizeFlg : false,
            colorSizeModal:{
                colSizList : []
            },
            dataColorSize:{},
            commonEc:commonEc,
            listIdErr:[]
        }
    },
    /*
    * 初期処理
    */
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            // 未ログインの場合はログイン画面へ
            if(_this.ptInitData.isLogin == false) {
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18}});
            } else {
                _this.pt440Init = _this.ptInitData;
                _this.getDataForPageFeed(_this.ptInitData);
                _this.dispPageSizeList = _this.pt440Init.pageSizeList;
                _this.favouriteSortKbnList = _this.pt440Init.favouriteSortKbnList;
                if (_this.favouriteSortKbnList != null && _this.favouriteSortKbnList.length > 0) {
                    _this.isSortDisp = true;
                }
            }
        }else{
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT440 + _this.$UrlConstants.DO_INIT, _this.pt440ReqModel).then(function(response) {
                // 未ログインの場合はログイン画面へ
                if(response.data.isLogin == false) {
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18}});
                } else {
                    _this.pt440Init = response.data;
                    _this.getDataForPageFeed(response.data);
                    _this.dispPageSizeList = _this.pt440Init.pageSizeList;
                    _this.favouriteSortKbnList = _this.pt440Init.favouriteSortKbnList;
                    if (_this.favouriteSortKbnList != null && _this.favouriteSortKbnList.length > 0) {
                        _this.isSortDisp = true;
                    }
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }

        //POPUPを閉じる処理
        EventBus.$on('closed', function() {
            _this.isModalShow = false;
        });
    },
    /*
    * Methods
    */
    methods: {
        /**
         * 表示順の切り替え処理
         * @param {Number} typeFlg, flag sort
         */
        doSort: function(typeFlg){
            var _this = this;
            if(typeFlg == 0){
                _this.pt440ReqModel.orderType == 0?_this.pt440ReqModel.orderType =1:_this.pt440ReqModel.orderType = 0;
            }
            if(typeFlg == 1){
                _this.pt440ReqModel.orderType == 2?_this.pt440ReqModel.orderType =3:_this.pt440ReqModel.orderType = 2;
            }
            _this.$emit("event-loading", true);
            // api
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT440 + _this.$UrlConstants.DO_SORT, _this.pt440ReqModel).then(function(response) {
                if(response.data.isLogin == false){
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18}});
                }else{
                    _this.pt440Init = response.data;
                    _this.getDataForPageFeed(response.data);
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        },
        /**
         * delete favorite product
         * @param {String} sItemNo, item product
         */
        doDelete: function(sItemNo){
            var _this = this;
            _this.pt440ReqModel.sItemNo = sItemNo;
            _this.$emit("event-loading", true);
            // api
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT440 + _this.$UrlConstants.DO_DELETE, _this.pt440ReqModel).then(function(response) {
                if(response.data.isLogin == false){
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18}});
                }else{
                    _this.pt440Init = response.data;
                    _this.getDataForPageFeed(response.data);
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        },
        /**
         * カートに入れるボタン押下処理
         * @param {String} sItemNo, item product
         */
        doOrder: function(sItemNo, price, itemNm, imgUrl) {
            var _this = this;
            _this.pt440ReqModel.sItemNo = sItemNo;
            _this.pt440ReqModel.price = price;
            _this.pt440ReqModel.itemNm = itemNm;

            var prdReq = {};
            prdReq.ordSItemNo = sItemNo;

            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT110 + _this.$UrlConstants.DO_AJAX, prdReq).then(function(response) {
                var colorSizeList = response.data.colSizList;
                // カラーサイズリストが存在する場合に表示
                if (common.getLengthObj(colorSizeList) > 0 && colorSizeList[0].VALUE != undefined) {
                    _this.colorSizeModal.colSizList = colorSizeList;
                     _this.colorSizeModal.csitemimg = imgUrl;
                    _this.dataColorSize = _this.colorSizeModal;
                    
                    // カラーサイズ表示フラグON
                    _this.colorSizeFlg = true;
                    return;
                } else {
                    _this.doOrderConfirm();
                }
            }).catch(function(error) {
                if(error != null && error != undefined){
                    common.errorAPI(error);
                }
            });
        },
        doOrderConfirm : function () {
            var _this = this;
            _this.doConfirm().then(function() {
                if(!_this.pt440Valid.sellFlg) {
                    alert(_this.pt440Valid.warning);
                } else {
                    var message1 = _this.$i18n.t('pt120.labels.itemCntCheck[0]');
                    var message2 = _this.$i18n.t('pt120.labels.itemCntCheck[1]');
                    if(_this.pt440Valid.itemCheckFlg == 1 && _this.pt440Valid.itemCnt > 0) {
                        if (!confirm(message1 + "\n" + message2)) {
                            return;
                        }
                    }
                    _this.confirmOrder();
                }
            });
        },
        /*
        * カラーサイズ商品コードセット
        */
        setValue(data){
            var _this = this;
            _this.pt440ReqModel.sItemNo = data.sItemNo;
            _this.doOrderConfirm();
        },
        /*
        * 戻るボタン押下処理
        */
        backUrl: function() {
            var _this = this;
            // マイメニュー画面へ遷移
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 81}});
        },
        doDetail: function(sItemNo){
            var _this = this;
            _this.$emit("event-loading", true);
            var ptPageNo = _this.pt440ReqModel.pageNo;
            var ptPageSize = _this.pt440ReqModel.pageSize;
            _this.$router.push({ name: SiteConstants.PG030, params :{pageNo: 3, sItemNo: sItemNo, backPageNo: 7,ptPageNo: ptPageNo, ptPageSize: ptPageSize}});
        },
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        formatPrice: function(value){
            return common.formatPrice(value);
        },
        /**
         * get length a object
         * @param {Object} obj, object to get length
         */
        getLengthObj: function(obj) {
            if(obj != undefined)
            return common.getLengthObj(obj);
        },
        //Methods for pageFeed
        changeSearch: function(sortNo, pageSize, pageNo) {
            this.pt440ReqModel.pageSize = pageSize;
            this.pt440ReqModel.pageNo = pageNo;
            this.pt440ReqModel.orderType = sortNo;
            this.doSort(0);
            //var queryString = this.getQueryString(pageSize, 'ptPageSize');
            //location.href = process.env.VUE_APP_PUBLIC_PATH + this.$route.path + '?' + queryString;
        },
        /**
         * get page size, page no
         * @param {Number} val
         * @param {String} type
         */
        getQueryString: function(val, type){
            var query = this.$route.query;
            query.ptPageNo = this.pt440ReqModel.pageNo;
            query.ptPageSize = this.pt440ReqModel.pageSize;
            query.ptOrderByType = this.pt440ReqModel.orderType;
            query[type] = val;

            var queryString = "";
            var index= 0;
            for(var propertyName in query) {
                if(index == 0){
                    queryString += propertyName + '=' + query[propertyName];
                } else{
                    queryString += '&' + propertyName + '=' + query[propertyName];
                }
                index++;
            }
            return queryString;
        },
        /**
         * get data for page feed
         * @param {Object} data, data from API
         */
        getDataForPageFeed: function(data){
            var _this = this;
            _this.pageFeedData.totalRecord = data.totalRecord;
            _this.pageFeedData.fromRecord = data.fromRecord;
            _this.pageFeedData.toRecord = data.toRecord;
            _this.pageFeedData.pageSize = data.pageSize;
            _this.pageFeedData.pageNo = data.pageNo;

            if(_this.pt440Init.favouriteList.length > 0){
                _this.isPagingDisplay = true;
            }else{
                _this.isPagingDisplay = false;
            }
        },

        doConfirm: function() {
            var _this = this;
            console.log(_this.pt440ReqModel.sItemNo);
            _this.$emit("event-loading", true);

            return axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT440 + _this.$UrlConstants.DO_CONFIRM, _this.pt440ReqModel)
            .then(function(response) {

                _this.$emit("event-loading", false);

                _this.pt440Valid = response.data;
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
				common.scrollTop();
            });
        },
        /*
        * カートに入れる処理
        */
        confirmOrder: function() {
            var _this = this;
            _this.$emit("event-loading", true);

            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT440 + _this.$UrlConstants.DO_ORDER, _this.pt440ReqModel).then(function(response) {
                if(response.data.isLogin == false) {
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18}});
                }else{
                    _this.pt440Init = response.data;
                    _this.getDataForPageFeed(response.data);
                    _this.msgConfirm = _this.pt440ReqModel.itemNm + _this.$i18n.t("pt110.labels.Order");
                    toastr.success(_this.msgConfirm);
                    _this.$emit('evt-change-quantily');
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error && error.response.status) {
                    var resultValid = common.excuteValidationEcSite(error);
                    if(resultValid) {
                        alert(resultValid.msgList);
                    }
                } else {
                    common.errorAPI(error);
                }
                common.scrollTop();
            });
        },
        /* 
        * 匹数から数量を算出する
        */
        getItemQty: async function(qty, index, syukkaNum){
            var _this = this;
            if(_this.pt440Init.auraOpt == 1){
                _this.pt440Init.favouriteList[index].QTY = (await commonEc.getItemQty(qty, syukkaNum)) % 1 !== 0 ? _this.pt440Init.favouriteList[index].QTY : await commonEc.getItemQty(qty, syukkaNum);
            }
        },
        /* 
        * 数量から匹数を算出する
        */
        getAnimalQty: async function(qty, index, syukkaNum){
            var _this = this;
            if(_this.pt440Init.auraOpt == 1){
                _this.pt440Init.favouriteList[index].ANIMAL_QTY = await commonEc.getAnimalQty(qty, syukkaNum);
            }
        },
                /*
        * カート追加処理縦レイアウト用
        */
        doOrderPt440 : function (ItemData) {
            var _this = this;
            common.clearMessageEcSite(_this.listIdErr, 'pt440');
            
            var itemCnt = 0;
            var sitemNos = [];
            var qtys = [];
            var animalQtys = [];
            var syukkaNums = [];
            // 数量が入力されていない場合はエラー
            for (var i = 0; i < ItemData.length; i++) {
                if (_this.pt440Init.auraOpt == 1){
                    if (ItemData[i].QTY >= 1 || ItemData[i].ANIMAL_QTY >= 1){
                        qtys[i] = ItemData[i].QTY;
                        animalQtys[i] = ItemData[i].ANIMAL_QTY;
                        sitemNos[i] = ItemData[i].S_ITEM_NO;
                        syukkaNums[i] = ItemData[i].SYUKKA_NUM;
                        if (ItemData[i].QTY >= 1){
                            itemCnt = itemCnt + 1;
                        } 
                    }
                } else {
                    if (ItemData[i].QTY >= 1) {
                        qtys[i] = ItemData[i].QTY;
                        animalQtys[i] = ItemData[i].ANIMAL_QTY;
                        sitemNos[i] = ItemData[i].S_ITEM_NO;
                        syukkaNums[i] = ItemData[i].SYUKKA_NUM;
                        itemCnt = itemCnt + 1;
                    }
                }
            }
            if(itemCnt == 0){
                _this.msgConfirm = _this.$i18n.t('pt440.labels.messenge')
                _this.isModalShow = true;
                return;
            }

            var reqModel = {};
            reqModel.sitemNos = sitemNos;
            reqModel.qtys = qtys;
            reqModel.animalQtys = animalQtys;
            reqModel.syukkaNums = syukkaNums;

            _this.$emit("event-loading", true);
            // カート追加処理
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT440 + _this.$UrlConstants.DO_INSERT, reqModel).then(function(response) {
                if(response.data.status == 'OK'){
                    _this.msgConfirm = _this.$i18n.t("pt440.labels.Order");
                    toastr.success(_this.msgConfirm);
                    _this.$emit('evt-change-quantily');
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                // eslint-disable-next-line
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, 'pt440');

                            if(resultValid){
                                if (resultValid.mapMsg[0].key == "count") {
                                    _this.msgConfirm = resultValid.mapMsg[0].mess;
                                } else {
                                    var key = resultValid.mapMsg[0].key;
                                    var count = key.split('_')[1];
                                    _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                    _this.msgConfirm = ItemData[count].WEB_ITEM_NM +" は"+ resultValid.mapMsg[0].mess;
                                }
                                
                                _this.isModalShow = true;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
    },
    created(){
        this.queryData = this.$route.query;
        if(this.queryData != null){
            if(this.queryData.ptPageNo != null){
                this.pt440ReqModel.pageNo = this.queryData.ptPageNo;
            }
            if(this.queryData.ptPageSize != null){
                this.pt440ReqModel.pageSize = this.queryData.ptPageSize;
            }
            if(this.queryData.ptOrderByType != null){
                this.pt440ReqModel.orderType = this.queryData.ptOrderByType;
            }
        }
    },
    beforeDestroy() {
        EventBus.$off('closed');
        EventBus.$off('is-loading');
    }
}
</script>
